'use strict'
import lottie from 'lottie-web' // Ajoute les animations Lottie/Body-movin 

function animLottie(container,path) {
    container = document.querySelector(container)
    path = process.env.MIX_THEME + '/dist/assets/lottie/' + path
    
    if(container){
        lottie.loadAnimation({
            container: container,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: path,
            rendererSettings: {
                scaleMode: 'noScale',
                progressiveLoad: true, // Boolean, only svg renderer, loads dom elements when needed. Might speed up initialization for large number of elements.
                hideOnTransparent: true, //Boolean, only svg renderer, hides elements when opacity reaches 0 (defaults to true)
                className: 'section--animation--lottie'
              }

        })
        // console.log(lottie.resize);
    
        
    }

}


export default animLottie; 
 


// WEBPACK FOOTER //
// ./src/scripts/components/AnimLottie.js